import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { BugsnagErrorBoundary } from '@pagerduty/bugsnag-reporter';

import { fetchFeData } from '../../features/fe-data/actions';
import { initNavbarTypeFromLocalStorage } from '../../features/navbar-type/actions';
import {
  isUserDataValid,
  isFeDataLoaded,
  isFeDataFetching,
} from '../../features/fe-data/selectors';
import { queryStringToObject } from '../../util/general';
import Navbar from '../Navbar';
import AnalyticsProvider from '../Analytics/Provider';
import FadeIn from '../Animations/FadeIn';
import EmptyNavbar from '../NavbarVariants/EmptyNavbar';

export class DisconnectedApp extends React.PureComponent {
  async componentDidMount() {
    await this.props.fetchFeData();
    this.props.initNavbarTypeFromLocalStorage();
  }

  getNavbarType() {
    // render empty until loaded
    if (!this.props.isDataLoaded) {
      return 'empty';
    }

    // type specified as a prop
    if (this.props.type) {
      return this.props.type;
    }

    // query param overrides other options
    const qp = queryStringToObject(window.location.search);
    if (qp.navbartype) {
      return qp.navbartype;
    }

    // default
    return this.props.navbarType;
  }

  render() {
    const hasError = !this.props.isDataFetching
      && (!isEmpty(this.props.error) || !this.props.isUserDataValid);
    const type = this.getNavbarType();

    return (
      <BugsnagErrorBoundary FallbackComponent={EmptyNavbar}>
        <FadeIn>
          <AnalyticsProvider>
            <Navbar
              type={type}
              loading={!this.props.isDataLoaded}
              error={hasError}
            />
          </AnalyticsProvider>
        </FadeIn>
      </BugsnagErrorBoundary>
    );
  }
}

DisconnectedApp.defaultProps = {
  error: {},
  type: undefined
};

DisconnectedApp.propTypes = {
  fetchFeData: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([PropTypes.object]),
  isUserDataValid: PropTypes.bool.isRequired,
  type: PropTypes.string,
  navbarType: PropTypes.string.isRequired,
  initNavbarTypeFromLocalStorage: PropTypes.func.isRequired,
  isDataLoaded: PropTypes.bool.isRequired,
  isDataFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  error: state.feData.error,
  isUserDataValid: isUserDataValid(state),
  navbarType: state.navbarType,
  isDataLoaded: isFeDataLoaded(state),
  isDataFetching: isFeDataFetching(state),
});

const mapActionsToProps = {
  fetchFeData,
  initNavbarTypeFromLocalStorage
};

export default connect(mapStateToProps, mapActionsToProps)(DisconnectedApp);
